import type { TFunction } from "i18next";

const USD_TO_IDR = 15000;
const USD_TO_CNY = 7.2;

function isIndonesian(language: string): boolean {
  return language.toLowerCase().startsWith("id");
}

function isChinese(language: string): boolean {
  return language.toLowerCase().startsWith("zh");
}

function formatUsd(amount: number): string {
  return `$${amount}`;
}

function formatIdr(amount: number): string {
  return `Rp${new Intl.NumberFormat("id-ID").format(amount)}`;
}

function formatCny(amount: number): string {
  return `¥${new Intl.NumberFormat("zh-CN").format(amount)}`;
}

export function formatPlanPrice(usdAmount: number, language: string): string {
  if (usdAmount === 0) {
    return "$0";
  }

  if (isIndonesian(language)) {
    return formatIdr(usdAmount * USD_TO_IDR);
  }

  if (isChinese(language)) {
    return `${formatUsd(usdAmount)} / ${formatCny(usdAmount * USD_TO_CNY)}`;
  }

  return formatUsd(usdAmount);
}

export function formatYearlyHelper(
  t: TFunction,
  translationKey: string,
  annualUsdAmount: number
): string {
  if (annualUsdAmount === 0) {
    return "";
  }

  return t(`landing.pricing_plans.${translationKey}.yearly_helper`, {
    usd: formatUsd(annualUsdAmount),
    idr: formatIdr(annualUsdAmount * USD_TO_IDR),
    cny: formatCny(annualUsdAmount * USD_TO_CNY),
    defaultValue: "",
  });
}
